import * as React from 'react';
import { useAiGeneratedDisclaimerStyles_unstable } from './useAiGeneratedDisclaimerStyles';
import { renderText_unstable, useText_unstable } from '@fluentui/react-components';
import { useCopilotMode } from '@fluentai/provider';
export const AiGeneratedDisclaimer = /*#__PURE__*/React.forwardRef((props, ref) => {
  const textState = useText_unstable({
    as: 'span',
    ...props
  }, ref);
  const state = textState;
  state.mode = useCopilotMode(props.mode);
  useAiGeneratedDisclaimerStyles_unstable(state);
  return renderText_unstable(state);
});
AiGeneratedDisclaimer.displayName = 'AiGeneratedDisclaimer';
//# sourceMappingURL=AiGeneratedDisclaimer.js.map